<template>
  <v-list-item v-if="!item.loading">
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <div style="display: flex">
          <div>
            <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail">
              {{ item.name }}
            </a>
            <span v-else> {{ item.name }} </span>
          </div>
          <v-spacer />
        </div>
      </v-list-item-title>
      <v-list-item-subtitle class="text-truncate text-xs">
        {{ item.iban }}
        -
        {{ item.bank }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-skeleton-loader v-else type="list-item-three-line" />
</template>

<script lang="ts">
import { PartnerBankingGoToHelper } from "@/lib/utility/partner-banking.go-to-helper";
import { IPartnerBanking } from "@/models/partner-banking.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsPartnerBanking extends mixins(Vue) implements IRefDetail<IPartnerBanking> {
  @Prop()
  item!: IPartnerBanking;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  get date() {
    return this.item.timestamp.createdReadable;
  }

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const partnerBankingId = this.item.id;
    const newTab = true;

    new PartnerBankingGoToHelper(this.$router).goToPartnerBankingDetail({ partnerBankingId, partnerId, newTab });
  }
}
</script>
<style lang="css" scoped>
.hoverCurserMouse :hover {
  cursor: pointer;
}
</style>
